<template>
  <div style="background-color: rgb(255, 255, 255); background-image: none; background-repeat: no-repeat;background-position:0 0; background:-moz-linear-gradient(top, none, none);background:-webkit-gradient(linear, left top, left bottom, from(none), to(none));background:-o-linear-gradient(top, none, none);background:-ms-linear-gradient(top, none, none);background:linear-gradient(top, none, none);;
         position: relative; width: 100%;min-width:1000px;background-size: auto;" bgScroll="none">
    <div class=" header" cpid="1133606" id="smv_Area0"
         style="width: 1000px; height: 84px;position: relative; margin: 0 auto">
      <div id="smv_tem_3_52" ctype="nav" class="esmartMargin smartAbs " cpid="1133606" cstyle="Style5"
           ccolor="Item0" areaId="Area0" isContainer="False" pvid="" tareaId="Area0" re-direction="all"
           daxis="All" isdeletable="True" style="height: 81px; width: 748px; left: 252px; top: 0px;z-index:3;">
        <div class="yibuFrameContent tem_3_52  nav_Style5  " style="overflow:visible;;">
          <div id="nav_tem_3_52" class="nav_pc_t_5">
            <ul class="w-nav" navstyle="style5">
              <li class="w-nav-inner" style="height:81px;line-height:81px;width:20%;"
                  v-for="(item, index) in navList" :key="index">
                <div class="w-nav-item">
                  <a :href="item.path" target="_self" class="w-nav-item-link">
                    <span class="mw-iconfont"></span>
                    <span v-if="item.select" class="w-link-txt is-select">{{ item.name }}</span>
                    <span v-else class="w-link-txt">{{ item.name }}</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="smv_tem_25_25" ctype="image" class="esmartMargin smartAbs " cpid="1133606" cstyle="Style1"
           ccolor="Item0" areaId="Area0" isContainer="False" pvid="" tareaId="Area0" re-direction="all"
           daxis="All" isdeletable="True" style="height: 84px; width: 251px; left: 0px;z-index:99;">
        <div class="yibuFrameContent tem_25_25  image_Style1  " style="overflow:visible;;">
          <div class="w-image-box image-clip-wrap" data-fillType="0" id="div_tem_25_25">
            <a target="_self" href="">
              <img
                  src="../../public/img/logo.png"
                  alt=""
                  title=""
                  id="img_smv_tem_25_25"
                  style="width: 249px; height:82px;"
                  class=""
              >
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  components: {},
  data() {
    return {
      navList: [
        {
          id: 0,
          path: '/',
          select: true,
          name: '首页'
        },
        {
          id: 1,
          path: '/#/about',
          select: false,
          name: '关于克罗兔'
        },
        {
          id: 2,
          path: '/#/products',
          select: false,
          name: '产品中心'
        },
        {
          id: 3,
          path: '/#/cpys',
          select: false,
          name: '产品优势'
        },
        {
          id: 4,
          path: '/#/contactus',
          select: false,
          name: '联系我们'
        }
      ]
    }
  },
  mounted() {
    let id = null
    switch (this.$route.name) {
      case 'home':
        id = 0
        break
      case 'about':
        id = 1
        break
      case 'products':
        id = 2
        break
      case 'cpys':
        id = 3
        break
      case 'contactus':
        id = 4
        break
    }
    for (const i in this.navList) {
      this.navList[i].select = parseInt(i) === id
    }
  },
  methods: {}
}
</script>

<style scoped>
.w-nav {
  margin: 0;
  padding: 0;
  border-top-width: 0px;
  border-right-width: 0;
  border-bottom-width: 0;
  border-left-width: 0px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: #ffffff;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: #ffffff;
  border-radius: 0;
  box-shadow: 0px 44px 0 rgb(0 0 0);
}

.w-nav-inner {
  padding: 0;
  margin: 0;
  float: left;
  list-style: none;
  width: 25%;
  height: 81px;
  line-height: 81px;
  background-color: transparent;
  background-image: none;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background: -webkit-linear-gradient(none, none);
  background: -moz-linear-gradient(none, none);
  background: -ms-linear-gradient(none, none);
  background: linear-gradient(none, none);
  background-size: auto;
}

.w-nav-item {
  background-color: #fff;
  background-image: none;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background: -webkit-linear-gradient(none, none);
  background: -moz-linear-gradient(none, none);
  background: -ms-linear-gradient(none, none);
  background: linear-gradient(none, none);
  background-size: auto;
}

.w-nav-item-link {
  margin: 0;
  padding: 0 15px;
  text-decoration: none;
  outline: none;
  display: block;
  height: 100%;
  color: #666;
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.w-nav-item-link:hover {
  color: #14C187;
}
.is-select {
  color: #14C187;
}
.w-link-txt {
  font-family: Tahoma;
  font-size: 17px;
}
</style>